import { ApiFieldForProfileDisplay } from "shared/types/ApiFieldForProfileDisplay";
import { OrganizationInfo } from "../../types";
import ViewProfileOverview from "../overview";
import React from "react";
import Image from "shared/form/core/image";
import FormGroup from "shared/form/fields/formGroup";
import { useCopies } from "shared/hooks/useCopies";

export default function OrganizationProfileOverview(props: {
  platformFieldsProfile?: OrganizationInfo;
  profile: Array<ApiFieldForProfileDisplay>;
}) {
  const copies = useCopies();
  return (
    <div className="orgProfileOverview orgProfileStatic">
      {props.platformFieldsProfile?.organizationBanner && (
        <div className="orgProfileOverview_image">
          <Image
            src={props.platformFieldsProfile?.organizationBanner}
            showLoadingAnimation={true}
            fallbackRenderer={" "}
          />
        </div>
      )}
      <div className={"form--flex profileOverview"}>
        {props.platformFieldsProfile?.organizationDescription && (
          <FormGroup fullWidth={true}>
            <div className="form_label">
              <span>{copies.get("display.profile.organization.description")}</span>
            </div>
            <div className={"form_value"}>{props.platformFieldsProfile?.organizationDescription}</div>
          </FormGroup>
        )}
        {props.platformFieldsProfile?.organizationLevel?.displayLabel && (
          <FormGroup>
            <div className="form_label">
              <span>{copies.get("sponsorship.level")}</span>
            </div>
            <div className={"form_value"}>{props.platformFieldsProfile?.organizationLevel?.displayLabel}</div>
          </FormGroup>
        )}
        {props.platformFieldsProfile?.organizationTagLine && (
          <FormGroup>
            <div className="form_label">
              <span>{copies.get("digital.ad.content")}</span>
            </div>
            <div className={"form_value"}>{props.platformFieldsProfile?.organizationTagLine}</div>
          </FormGroup>
        )}
      </div>
      <ViewProfileOverview profile={props.profile} />
    </div>
  );
}
